function n(n){return function(){return n}}function r(n){return"object"==typeof n&&"length"in n?n:Array.from(n)}export{r as a,n as c};
//# sourceMappingURL=array-5b770a93.js.map
